import { Box, IconButton, Image, SkeletonLine, Text, Tooltip, Transition } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/react';
import { Maximize } from '@wix/wix-ui-icons-common';
import React from 'react';
import { HTTP_PREFIX } from '../../../../consts';
import { dataHooks } from '../../../../utils/datahooks';
import { resolveImageUrl } from '../../../../utils/resolve-image-url';
export const AltImageRuleHeader = _ref => {
  let {
    id,
    isOpen,
    isDecorative,
    alt,
    previousOpenElementId,
    disabled = false,
    isLoading = false,
    enlargeImage,
    handleImageSize,
    index,
    status,
    dataHook
  } = _ref;
  const {
    t
  } = useTranslation();
  const renderMinimizedImage = () => {
    const urlToShow = enlargeImage.url.startsWith(HTTP_PREFIX) ? enlargeImage.url : resolveImageUrl(enlargeImage.url, enlargeImage.minimizedImageWidth, enlargeImage.minimizedImageHeight);
    return /*#__PURE__*/React.createElement(Image, {
      borderRadius: "4px",
      dataHook: dataHooks.altImageRuleHeaderImage(dataHook),
      fit: "fill",
      height: enlargeImage.minimizedImageHeight,
      src: urlToShow,
      width: enlargeImage.minimizedImageWidth,
      onClick: event => handleImageSize(index, status, event)
    });
  };
  const renderMinimizedImageAndEnlargeButton = () => {
    return /*#__PURE__*/React.createElement(Transition, {
      dataHook: dataHooks.altImageRuleHeaderImageTransition(dataHook),
      enterAnimation: {
        fadeIn: {
          delay: 'long',
          duration: 'fast02',
          easing: 'enterEasing'
        }
      },
      exitAnimation: {
        fadeOut: {
          duration: 'fast02',
          easing: 'exitEasing'
        }
      },
      show: !enlargeImage.isImageEnlarged
    }, /*#__PURE__*/React.createElement(Box, {
      direction: "horizontal",
      gap: "3px",
      verticalAlign: "middle"
    }, renderMinimizedImage(), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Tooltip, {
      content: t('accessibility-wizard.alt-text.enlarge-image-icon-button.tooltip'),
      size: "small"
    }, /*#__PURE__*/React.createElement(Box, {
      paddingBottom: "2px",
      paddingTop: "2px"
    }, /*#__PURE__*/React.createElement(IconButton, {
      dataHook: dataHooks.altImageRuleHeaderEnlargeImageIconButton(dataHook),
      priority: "secondary",
      size: "small",
      skin: "light",
      onClick: event => {
        handleImageSize(index, status, event);
      }
    }, /*#__PURE__*/React.createElement(Maximize, {
      color: "#116DFF"
    })))))));
  };
  return /*#__PURE__*/React.createElement(Box, {
    alignSelf: "center",
    cursor: disabled ? 'default' : 'pointer',
    width: "216px"
  }, isOpen ? renderMinimizedImageAndEnlargeButton() : renderMinimizedImage(), !isOpen && /*#__PURE__*/React.createElement(Box, {
    marginLeft: "SP2",
    verticalAlign: "middle",
    width: "170px"
  }, isLoading ? /*#__PURE__*/React.createElement(SkeletonLine, {
    width: "160px"
  }) : isDecorative || alt ? /*#__PURE__*/React.createElement(Text, {
    maxLines: 2,
    size: "tiny",
    weight: "normal",
    zIndex: 1,
    ellipsis: true,
    secondary: true
  }, isDecorative ? t('accessibility-wizard.rules-list.alt-image.decorative-image-title-value') : alt) : previousOpenElementId !== id && /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    ellipsis: true,
    light: true,
    secondary: true
  }, t('accessibility-wizard.rules-list.alt-image.default-title-value.drill-in')))));
};
//# sourceMappingURL=alt-image-rule-header.js.map